export default "__VITE_ASSET__BfGTKx$T__"